import { TaikyoEntity } from "~/api/data/TaikyoEntity";
import { RoomSb, TaikyoRiyuKb } from "~/extensions/utils/DefineTypes";
/**
 * 退去申請入力画面ViewModel
 */
export class TaikyoEntryPageViewModel {
    /**
     * @param model 退去申請情報
     * @param userKb 個人情報ストア.法人区分
     * @param roomType 個人情報ストア.入居契約リストルーム種別
     */
    constructor(model, roomType) {
        this.model = model;
        this.roomType = roomType;
    }
    model = new TaikyoEntity();
    /** ルーム種別 */
    roomType = -1;
    get isParkingContract() {
        return this.roomType === RoomSb.Parking;
    }
    /** 退去理由の詳細必須条件 */
    get isRequiredTaikyoRiyu() {
        return this.model.taikyoRiyuKb === TaikyoRiyuKb.Other || this.model.taikyoRiyuKb === TaikyoRiyuKb.DissatisfactionOrTrouble;
    }
    /** 退去理由の詳細活性条件 */
    get isDisableTaikyoRiyu() {
        return this.model.taikyoRiyuKb !== TaikyoRiyuKb.Other && this.model.taikyoRiyuKb !== TaikyoRiyuKb.DissatisfactionOrTrouble;
    }
}
